"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var minifiedActions_1 = __importDefault(require("../../../CreateUrlModal/helpers/minifiedActions"));
var download_1 = require("../../../../../app/util/download");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        downloadButtonContainer: {
            marginLeft: 20,
            width: '150px',
            flexShrink: 0,
        },
        downloadButton: {
            border: "solid 1px " + theme.palette.primary.main,
            height: '100%',
            width: '150px',
        },
    });
});
var DownloadButton = function () {
    var classes = useStyles();
    var tableConfig = react_redux_1.useSelector(function (state) { return state.user.tableConfig; });
    return (
    // Only shown when actions are not minified.
    react_1.default.createElement(react_1.default.Fragment, null, !minifiedActions_1.default() && (react_1.default.createElement("span", { className: classes.downloadButtonContainer },
        react_1.default.createElement(core_1.Button, { variant: "outlined", color: "primary", onClick: function () { return download_1.downloadUrls(tableConfig); }, className: classes.downloadButton },
            react_1.default.createElement(core_1.Typography, { variant: "body2" }, "Download links"))))));
};
exports.default = DownloadButton;
